//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../CAM/CAM.MoveBuilder.js";
let d=[[[0,"EndPositionType",1,0],[0,"FirstCurve",1,"NXObject",0],[0,"FirstCurveStock",1,0],[0,"FirstCurveToolPosition",1,0],[0,"InitialRetractAngle",1,0],[0,"InitialRetractDistance",1,0],[0,"InitialRetractType",1,0],[0,"MoveType",1,0],[0,"Point",1,"Point",0],[0,"SecondCurve",1,"NXObject",0],[0,"SecondCurveStock",1,0],[0,"SecondCurveToolPosition",1,0],[0,"ToolHolderAngle",1,0]],[],[]];
SPLM.CAM.TeachmodeLinearMoveBuilder = class extends SPLM.CAM.MoveBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.TeachmodeLinearMoveBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.TeachmodeLinearMoveBuilder.MoveTypes = Object.freeze({
    "Direct" : "Direct", "Radial" : "Radial", "Axial" : "Axial", "RadialAxial" : "RadialAxial", "AxialRadial" : "AxialRadial"});

SPLM.CAM.TeachmodeLinearMoveBuilder.EndPositionTypes = Object.freeze({
    "Point" : "Point", "Curves" : "Curves"});

SPLM.CAM.TeachmodeLinearMoveBuilder.CurveToolPositionTypes = Object.freeze({
    "To" : "To", "On" : "On", "Past" : "Past"});

SPLM.CAM.TeachmodeLinearMoveBuilder.InitialRetractTypes = Object.freeze({
    "None" : "None", "LinearAuto" : "LinearAuto", "Linear" : "Linear"});

export default SPLM;